import httpServiceAuth from '@/services/http-service';
import store from '@/store';
import { apiEndpoints } from '@/services/constants';
export default {
  namespaced: true,
  state: {
    editing: false,
    cameraActive: false,
    recordingStarted: false,
    cameraScreenId: null,
    userNotifications: null,
  },
  mutations: {
    updateEditingStatus(state, payload) {
      state.editing = payload;
    },
    setCameraActive(state, payload) {
      state.cameraActive = payload;
    },
    setCameraRecordingStatus(state, payload) {
      state.recordingStarted = payload;
    },
    setCameraScreenId(state, payload) {
      state.cameraScreenId = payload;
    },
    setUserNotifications(state, payload) {
      state.userNotifications = payload;
    },
  },
  actions: {
    updateEditingStatus({ commit }, payload) {
      commit('updateEditingStatus', payload);
    },
    setCameraActive({ commit }, payload) {
      commit('setCameraActive', payload);
    },
    setCameraRecordingStatus({ commit }, payload) {
      commit('setCameraRecordingStatus', payload);
    },
    setCameraScreenId({ commit }, payload) {
      commit('setCameraScreenId', payload);
    },
    getUserNotifications({ state }) {
      store.dispatch('pagination/paginate', {
        whatToCall: 'profile/getUserNotifications',
        whereToSave: 'profile/setUserNotifications',
        url: apiEndpoints.company.userNotifications,
        data: state.userNotifications,
        params: {},
      });
    },
    setUserNotifications({ commit }, payload) {
      commit('setUserNotifications', payload);
    },
    deleteUserNotification({ commit }, id) {
      commit('loader/setScreenLoading', true, { root: true });
      let url = `${apiEndpoints.company.userNotifications}/${id}`;
      return httpServiceAuth.delete(url).finally(() => {
        commit('loader/setScreenLoading', false, { root: true });
      });
    },
  },
};
